export class Vehicule{
	idVehicule:number;
	matricule:string;
    pathGrayCard :string;
	constructor(){}
}

export class Group{
	idGroupe:number;
	nom:string
	constructor(){}
}
export class RunningDocumentInfo{
	id:number;
    operationTime:number;
    endTime:number;
    cost:number;
    providerName:string;
    idProvider:number;
    constructor(){
    }
}   
export class RunningDocument{
    id:number;
    operationTime:number;
    endTime:number;
    cost:number;
    type:string;
    constructor(){
    }
}
export class Provider{
	id:number;
    name:string;
    constructor(){
    }
}

export class Type{
    id:number;
    name:string;
    constructor(){
        this.id=0;
        
    }
}
export class TypeOil{
    value:number;
    name:string;
    constructor(){
    }
}
export class LastDates{
    insurance:Date;
    visit:Date;
    certification:Date;
    taxe:Date;
    permit:Date;
    constructor(){
    }
}
  
export class Fueling{
    id:number;
    operationTime:number;
    quantity:number;
    costUnit:number;
    odometre:number;
    numberPayment:number;
    cost : number;
    observation:string;
    constructor(){
    
    }
}

export class FuelingInfo{
    id:number;
    operationTime:number;
    quantity:number;
    costUnit:number;
    odometre:number;
    numberPayment:number;
    type:Type;
    observation:string;
    idProvider:number;
    providerName:string;
    cost : number;
    constructor(){
        this.type=new Type();
    }
}

export class OilChange{
    id:number;
    operationTime:number;
    quantity:number;
    cost : number;
    observation:string;
    engineOil :Boolean;
    typeEngineOil :number;    
    oilF :Boolean;
    typeOilF :number;
    airF :Boolean;
    typeAirF :number;
    fuelF :Boolean;
    typeFuelF :number;
    separatorF :Boolean;
    typeSeparatorF :number;
    constructor(){
    
    }
}

export class OilChangeInfo{
    id:number;
    operationTime:number;
    quantity:number;
    cost : number;
    observation:string;
    engineOil :Boolean;
    typeEngineOil :number;    
    oilF :Boolean;
    typeOilF :number;
    airF :Boolean;
    typeAirF :number;
    fuelF :Boolean;
    typeFuelF :number;
    separatorF :Boolean;
    typeSeparatorF :number;
    idProvider:number;
    providerName:string;
    constructor(){
    }
}
export class Tire{
    id:number;
    operationTime:number;
    buyDate:number;
    number:number;
    maxKm:number;
    kmMontage:number;
    cost:number;
    mark:string;
    serieNumber:string;
    position : string;
    observation:string;
    constructor(){
    
    }
}

export class TireInfo{
    id:number;
    operationTime:number;
    buyDate:number;
    number:number;
    maxKm:number;
    kmMontage:number;
    cost:number;
    mark:string;
    serieNumber:string;
    position : string;
    observation:string;
    idProvider:number;
    providerName:string;
    constructor(){
    }
}

    export class Battery{
    id:number;
    operationTime:number;
    expirationDate:number;
    number:number;
    duration:number;
    cost:number;
    mark:string;
    serieNumber:string;
    observation:string;
    amperage : number;
    voltage : number;
    constructor(){
    
    }
}

export class BatteryInfo{
    id:number;
    operationTime:number;
    expirationDate:number;
    number:number;
    duration:number;
    cost:number;
    mark:string;
    serieNumber:string;
    observation:string;
    amperage : number;
    voltage : number;
    idProvider:number;
    providerName:string;
    constructor(){
    }



}

export class Reparation{
    id:number;
    operationTime:number;
    quantity:number;
    cost:number;
    odometre:number;
    observation:string;
    constructor(){
    
    }
}

export class ReparationInfo{
    id:number;
    operationTime:number;
    quantity:number;
    cost:number;
    odometre:number;
    observation:string;
    type:Type;
    idProvider:number;
    providerName:string;
    constructor(){
    }
}
export class DashbordInfo{
    runningDocument:number;
    fuel:number;
    oilChange:number;
    tireMaintenance:number;
    batteryMaintenance:number;
    reparation:number;
    constructor(){
    }
}

export class DateInterval{
    startDate :number;
    endDate : number;
        constructor(){

    }
}


// WEBPACK FOOTER //
// ./src/pages/gestion-park/model/index.ts